import React from "react";
import s from "./style.module.css";
import useVizualisation from "../../../../helpers/useVizualisation";
import Vizualisation from "../../../../components/Vizualisation";

const CrossReference = ({
  data,
  title,
  note,
  source,
  text,
  href,
  type,
  size = "default",
}) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();

  return (
    <Vizualisation className={s.wrap} ref={ref} size={size}>
      <a href={"#" + href}>
        <div className={s.wrap}>
          {type === "tosurvey" ? text + " 👇" : text + " ☝"}
        </div>
      </a>
    </Vizualisation>
  );
};

export default CrossReference;
